import { useRecordContext, Button } from "react-admin";
import { useNavigate } from "react-router";
import Box from "@mui/material/Box";
import LinkIcon from "@mui/icons-material/Link";
import { RankingStatus } from "utils/constants";
import { candidateRequests } from "api/candidateApi";
import SecuredComponent from "server/security/SecuredComponent";
import permissions from "app/permissions";
import React from "react";
import ApproveRankingButton from "./ApproveRankingButton";
import GenerateRankingButton from "./GenerateRankingButton";
import AdditionalCapacityButton from "./AdditionalCapacityButton";

const RankingButtons = ({ isFinished, hasPaidDraftGenerated }) => {
  const record = useRecordContext();
  const navigate = useNavigate();

  const status = record?.status;
  const recordUrl = candidateRequests.campaignRanking(record?.id);

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "row",
        gap: 2,
      }}
    >
      <GenerateRankingButton isFinished={isFinished} hasPaidDraftGenerated={hasPaidDraftGenerated} />
      <SecuredComponent permission={permissions.canPreviewCampaignRankings}>
        <Button
          label="Детайли"
          onClick={() => navigate(`/${recordUrl}/show`)}
          variant="outlined"
          size="medium"
          sx={{ display: status === RankingStatus.Pending ? "none" : "flex" }}
        >
          <LinkIcon />
        </Button>
      </SecuredComponent>
      <ApproveRankingButton />
      <AdditionalCapacityButton />
    </Box>
  );
};

export default RankingButtons;
